<template>
    <div class="login-dialog-box" v-show="isShowLoginDialog">
        <div class="login-dialog-mask"></div>
        <div class="login-dialog">
            <a class="login-dialog-close" @click="closeLoginDialog"></a>
            <ul class="way-tab">
                <li v-for="(item, index) in title" :class="item.isSelected ? 'current': ''"
                    @click="changeTabShow(index)">{{item.name}}
                </li>
            </ul>
            <div class="login-dialog-content">
                <div class="password-login-box" v-if="isShowTab1">
                    <div class="msgTips">
                        <div class="successTips" v-if="isTab1Success && isShowTip1">
                            <i></i>
                            <span>
                                {{this.tipMsg1}}
                            </span>
                        </div>
                        <div class="errorTips" v-if="!isTab1Success && isShowTip1">
                            <i></i>
                            <span>
                                {{this.tipMsg1}}
                            </span>
                        </div>
                    </div>
                    <Form ref="loginDialog" :model="passwordLogin">
                        <FormItem prop="username" class="form-item">
                            <i class="user-icon"></i>
                            <Input focus v-model="passwordLogin.username" :maxlength="maxLength64"
                                   placeholder="用户名/手机号"/>
                        </FormItem>
                        <FormItem prop="password" class="form-item">
                            <i class="password-icon"></i>
                            <Input v-model="passwordLogin.password" type="password" :maxlength="maxLength16"
                                   placeholder="账户密码"/>
                        </FormItem>
                        <FormItem prop="imgCode" v-if="isShowImgCode" class="form-item">
                            <i class="img-code-icon"></i>
                            <Input v-model="passwordLogin.imgCode" :maxlength="maxLength6" class="img-code-input"
                                   placeholder="请输入右侧验证码"/>
                            <img :src="imgCodeUrl"
                                 class="img-code" alt="" @click="refreshImgCode">
                        </FormItem>
                        <Checkbox class="remember-count" v-model="rememberCount">记住账号</Checkbox>
                    </Form>
                    <Button type="primary" class="submit-password-login" @click="loginByUserCount">
                        <span v-if="!loginByUserCountLoading">登 录</span>
                        <span v-else>Loading...</span>
                    </Button>
                </div>
                <div class="password-login-box" v-if="!isShowTab1">
                    <div class="msgTips">
                        <div class="errorTips" v-if="!isTab2Success  && isShowTip2">
                            <i></i>
                            <span>
                                {{this.tipMsg2}}
                            </span>
                        </div>
                        <div class="successTips" v-if="isTab2Success && isShowTip2">
                            <i></i>
                            <span>
                                {{this.tipMsg2}}
                            </span>
                        </div>
                    </div>
                    <Form ref="loginDialog" :model="mobileLogin">
                        <FormItem prop="mobile" class="form-item">
                            <i class="user-icon"></i>
                            <Input v-model="mobileLogin.mobile" :maxlength="maxLength11"
                                   placeholder="手机号"/>
                        </FormItem>
                        <div class="form-item">
                            <FormItem prop="mobileCode" class="mobile-code">
                                <i class="password-icon"></i>
                                <Input v-model="mobileLogin.mobileCode" :maxlength="maxLength6"
                                       placeholder="短信验证码"/>
                            </FormItem>
                            <Button class="time-count" @click="getMobileCode" :loading="loading">
                                <span v-if="!loading">{{getMobileCodeTxt}}</span>
                                <span v-else>发送中...</span>
                            </Button>
                        </div>
                    </Form>
                    <Button type="primary" class="submit-password-login" :loading="loginByMobileLoading"
                            @click="loginByMobile">
                        <span v-if="!loginByMobileLoading">登 录</span>
                        <span v-else>Loading...</span>
                    </Button>
                </div>
            </div>
            <div class="login-dialog-bottom">
                <div class="other-link">
                    <a :href="register" target="_self">立即注册</a>
                    <span></span>
                    <a :href="forgotPassword" target="_self">忘记密码？</a>
                </div>
                <p class="login-dialog-tips">
                    正在使用SSL安全登录
                </p>
            </div>
        </div>
    </div>
</template>
<script>
    import url from '../../../config/url';
    import common from '../../../static/js/common';
    let Base64 = require('js-base64').Base64;
    export default {
        props: {
            isRefreshTop: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                loginByUserCountLoading: false,
                loginByMobileLoading: false,
                register: url.register,
                forgotPassword: url.forgotPassword,
                smsId: "",
                isShowTip1: false,
                isShowTip2: false,
                isTab1Success: true,
                sessionKey:new Date().getTime() + parseInt(Math.random() * 1000000),
                tipMsg1: "",
                isTab2Success: true,
                tipMsg2: "",
                loading: false,
                imgCodeUrl: "",
                getMobileCodeTxt: "点击获取",
                isCanGetMobileCode: true, //是否能点击获取验证码
                hasClickGetMobileCode: false, //是否点击过获取验证码
                title: [
                    {
                        name: "密码登录",
                        isSelected: true
                    }, {
                        name: "手机短信登录",
                        isSelected: false
                    },
                ],
                isShowTab1: true,
                isShow: true,
                maxLength64: 64,
                maxLength16: 16,
                maxLength6: 6,
                maxLength11: 11,
                isShowImgCode: false,
                rememberCount: false,
                passwordLogin: {
                    username: "",
                    password: "",
                    imgCode: ""
                },
                mobileLogin: {
                    mobile: "",
                    mobileCode: ""
                },
                passwordLoginValidate1: {
                    username: [
                        {required: true, message: '请输入用户名', trigger: 'blur'},
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                    ],
                },
                passwordLoginValidate2: {
                    username: [
                        {required: true, message: '请输入用户名', trigger: 'blur'},
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                    ],
                    imgCode: [
                        {required: true, message: '请输入图形验证码', trigger: 'blur'},
                    ]
                },
                mobileLoginValidate: {
                    mobile: [
                        {required: true, message: '请输入手机号码', trigger: 'blur'},
                        {
                            validator(rule, value, callback) {
                                var errors = [];
                                if (!((value.match(/^(13|15|17|18|14)[0-9]{9}$/)))) {
                                    callback('手机号码格式不正确');
                                }
                                callback(errors);
                            }, trigger: 'blur'
                        }
                    ],
                    mobileCode: [
                        {required: true, message: '请输入短信验证码', trigger: 'blur'},
                    ],
                }
            }
        },
        created: function () {
            this.getPicCheckFlag();
            if(common.getCookie("wanjia_passport_user_name")){
                this.passwordLogin.username = Base64.decode((common.getCookie("wanjia_passport_user_name")).replace("%3D%3D", ""));
            }
        },
        mounted: function () {
        },
        computed:{
            isShowLoginDialog(){
                return this.$store.state.isShowLoginDialog
            }
        },
        methods: {
            //判断是否显示验证码
            getPicCheckFlag() {
                var _this = this;
                _this.$http.jsonp(url.getPicCheckFlag, {
                    'jsonp': 'jsonpCallback',
                }).then(function (res) {
                    var r = res.body;
                    /*r.result = "yes";*/
                    if (r.result == "yes") {
                        _this.isShowImgCode = true;
                        _this.refreshImgCode();
                    }else{
                        _this.isShowImgCode = false;
                    }
                }).catch(function () {
                });
            },
            //检查用户名格式
            userCountValidateCheck() {
                var _this = this;
                if (_this.passwordLogin.username.trim().length <= 0) {
                    _this.isShowTip1 = true;
                    _this.isTab1Success = false;
                    _this.tipMsg1 = "用户名不能为空！";
                    return false;
                } else {
                    return true;
                }
            },
            //检查密码格式
            passwordValidateCheck() {
                var _this = this;
                if (_this.passwordLogin.password.trim().length <= 0) {
                    _this.isShowTip1 = true;
                    _this.isTab1Success = false;
                    _this.tipMsg1 = "密码不能为空！";
                    return false;
                } else {
                    return true;
                }
            },
            //检查图形验证码
            imgCodeValidateCheck() {
                var _this = this;
                if (_this.isShowImgCode) {
                    if (_this.passwordLogin.imgCode.trim().length <= 0) {
                        _this.isShowTip1 = true;
                        _this.isTab1Success = false;
                        _this.tipMsg1 = "图形验证码不能为空！";
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return true
                }
            },
            //检查手机验证码格式
            mobileCodeValidateCheck() {
                var _this = this;
                if (_this.mobileLogin.mobileCode.trim().length <= 0) {
                    _this.isShowTip2 = true;
                    _this.isTab2Success = false;
                    _this.tipMsg2 = "手机验证码不能为空";
                    return false;
                } else if (_this.mobileLogin.mobileCode.trim().length != 6) {
                    _this.isShowTip2 = true;
                    _this.isTab2Success = false;
                    _this.tipMsg2 = "手机验证码格式不正确";
                    return false;
                } else {
                    return true;
                }
            },
            //检查手机格式
            mobileValidateCheck() {
                var _this = this;
                if (_this.mobileLogin.mobile.trim().length <= 0) {
                    _this.isShowTip2 = true;
                    _this.isTab2Success = false;
                    _this.tipMsg2 = "手机号码不能为空";
                    return false;
                } else if (!(_this.mobileLogin.mobile.trim().match(/^(13|15|17|18|14)[0-9]{9}$/))) {
                    _this.isShowTip2 = true;
                    _this.isTab2Success = false;
                    _this.tipMsg2 = "手机号码格式不正确";
                    return false;
                } else {
                    return true;
                }
            },
            //短信验证码方式登录
            loginByMobile() {
                var _this = this;
                if (!_this.mobileValidateCheck()) {
                    return;
                }
                if (!_this.hasClickGetMobileCode) {
                    _this.isShowTip2 = true;
                    _this.isTab2Success = false;
                    _this.tipMsg2 = "请获取短信验证码！";
                    return;
                }
                if (!_this.mobileCodeValidateCheck()) {
                    return
                }
                _this.loginByMobileLoading = true;
                var params = {
                    sessionId: "dsads#ae3sdasdwqw",
                    mobileNum: _this.mobileLogin.mobile.trim(),
                    smsCode: _this.mobileLogin.mobileCode.trim(),
                    smsId: _this.smsId
                };
                _this.$http.jsonp(url.loginByMobile, {
                    params: params,
                    jsonp: 'jsonpCallback'
                }).then(function (res) {
                    _this.loginByMobileLoading = false;
                    var res = res.body;
                    if (res.status == "ERROR") {
                        _this.isShowTip2 = true;
                        _this.isTab2Success = false;
                        if (typeof(res.errorMsg) != undefined) {
                            if (res.errorCode == "smsCodeError") {
                                _this.tipMsg2 = '动态码错误，您还能输入' + res.result + '次';
                            } else {
                                if(res.errorMsg == ""){
                                    _this.tipMsg2 = "系统繁忙,登录失败!";
                                }else{
                                    _this.tipMsg2 = res.errorMsg;
                                }
                            }
                        } else {
                            _this.tipMsg2 = "系统繁忙,登录失败!";
                        }
                    } else {
                        var params = {
                            x: _this.sessionKey,
                            userName: _this.mobileLogin.mobile.trim(),
                            userPwd: _this.mobileLogin.mobileCode.trim()
                        };
                        _this.loginSSO(params);
                        _this.isShowTip2 = false;
                        _this.$store.commit('changeShowLoginDialogState');
                    }

                }).catch(function () {
                    _this.loading = false;
                    _this.loginByMobileLoading = false;
                    _this.$store.commit('changeShowLoginDialogState');
                    console.log('数据获取失败,请稍后再试!');
                });
            },
            //获取图形验证码
            refreshImgCode(){
                var _this = this;
                if(_this.isShowImgCode){
                    _this.sessionKey = new Date().getTime() + parseInt(Math.random() * 1000000);
                    _this.imgCodeUrl = window.nginxRoot + "/verification/code/num/web/6/"+ _this.sessionKey + "/180";
                }
            },
            loginByUserCount() {
                var _this = this;
                if(!_this.userCountValidateCheck()){
                    return
                }
                if(!_this.passwordValidateCheck()){
                    return;
                }
                if(!_this.imgCodeValidateCheck()){
                    return;
                }
                _this.loginByUserCountLoading = true;

                if(_this.isShowImgCode){
                    var params = {
                        sessionKey: _this.sessionKey,
                        randomCode: _this.passwordLogin.imgCode.trim(),
                        userId: _this.passwordLogin.username.trim(),
                        userPwd: _this.passwordLogin.password.trim()
                    };
                }else {
                    var params = {
                        sessionKey: _this.sessionKey,
                        userId: _this.passwordLogin.username.trim(),
                        userPwd: _this.passwordLogin.password.trim()
                    };
                }
                //勾选了记住账号密码，就存放在cookie中
                if(_this.rememberCount){
                    var _count = Base64.encode(_this.passwordLogin.username.trim()).replace("==", "");
                    common.setCookie("wanjia_passport_user_name", _count, 12 * 30);
                }
                _this.$http.jsonp(url.loginByWeb, {
                    params: params,
                    'jsonp': 'jsonpCallback',
                }).then(function (res) {
                    _this.loginByUserCountLoading = false;
                    var result = res.body;
                    if (result.status == "SUCCESS") {
                        if(_this.isShowImgCode){
                            var ssoParams = {
                                userName:_this.passwordLogin.username,
                                userPwd: _this.passwordLogin.password,
                                x: _this.sessionKey,
                                sessionKey:_this.sessionKey,
                                randomCode:_this.passwordLogin.imgCode
                            };
                        }else{
                            var ssoParams = {
                                userName:_this.passwordLogin.username,
                                userPwd: _this.passwordLogin.password,
                                x: _this.sessionKey,
                                sessionKey:_this.sessionKey,
                            };
                        }
                        _this.loginSSO(ssoParams);
                        _this.isShowTip1 = false;
                        _this.$store.commit('changeShowLoginDialogState');
                    } else {
                        if (result.errorCode == "needActiveByMail") {
                            // 用户需要通过邮箱激活，跳转激活页面
                            window.location.href= casRoot + "/email?q=" + result.result;
                            return;
                        }
                        _this.isShowTip1 = true;
                        _this.isTab1Success = false;
                        _this.getPicCheckFlag();
                        if (result.errorCode == "timeOut") {
                            _this.tipMsg1 = "页面信息已失效,请重新刷新页面";
                        } else if (result.errorCode == "userUnExist") {
                            _this.tipMsg1 = "该用户名尚未注册";
                        } else if (result.errorCode == "userInactive") {
                            _this.tipMsg1 = "该用户尚未激活";
                        } else if (result.errorCode == "userDisable") {
                            _this.tipMsg1 = "该账号已停用";
                        } else if (result.errorCode == "accountLocked") {
                            _this.tipMsg1 = "账户已锁定，请2小时后重试";
                        } else if(result.errorCode == 'authError'){
                            if(result.result && result.result != null && result.result != ''){
                                _this.tipMsg1 = "用户名或密码错误,您还能尝试" + result.result + "次";
                            } else {
                                _this.tipMsg1 = "用户名或密码错误";
                            }
                        } else if (result.errorCode == "accountLockedForever") {
                            _this.tipMsg1 = "账户被永久锁定，请与客服人员联系";
                        } else if (result.errorCode == "pwdUnExist") {
                            _this.tipMsg1 = "该用户名暂未设置密码，请使用动态码登录";
                        } else if (result.errorCode == "userExperied") {
                            _this.tipMsg1 = "账户已失效";
                        } else if (result.errorCode == "pwderror") {
                            _this.tipMsg1 = "密码错误，您还能输入" + result.result + "次";
                        } else if (result.errorCode == "pwdExperied" || result.errorCode == "initFromDB" || result.errorCode == "initFromAdmin" || result.errorCode == "pwdTooSimple") {
                            _this.tipMsg1 = "您的登录密码已过期，为了您的账户安全，请重新设置您的登录密码。";
                        } else {
                            if(typeof(result.errorMsg) != undefined && result.errorMsg != null){
                                _this.tipMsg1 = result.errorMsg
                            } else {
                                _this.tipMsg1 = "系统繁忙，请稍后再试！";
                            }
                        }
                    }
                }).catch(function () {
                    _this.loading = false;
                    _this.loginByMobileLoading = false;
                    console.log('数据获取失败,请稍后再试');
                });

            },

            //登录成功后调用sso
            loginSSO(params) {
                var _this = this;
                _this.$http.jsonp(url.loginSSO, {
                    params: params,
                    'jsonp': 'jsonpCallback',
                }).then(function () {
                    if(common.isIE()){
                        window.location.reload();
                    }else{
                        _this.$store.dispatch("getCartNum");
                        _this.$store.dispatch("getUserInfo", _this.loginSuccessCallBack());
                    }
                }).catch(function () {
                    if(common.isIE()){
                        window.location.reload();
                    }else{
                        _this.$store.dispatch("getCartNum");
                        _this.$store.dispatch("getUserInfo", _this.loginSuccessCallBack());
                    }
                });
            },
            loginSuccessCallBack(){
                var count = 0;
                var _this = this;
                var timer = setInterval(function () {
                    var userInfo = _this.$store.state.userInfo;
                    count++;
                    if(count > 2000){
                        clearInterval(timer)
                    }else{
                        if(userInfo != null && userInfo.userId > 0){
                            if(common.isIE()){
                                window.location.reload();
                            }else{
                                _this.$emit('on-success');
                                clearInterval(timer);
                            }
                        }
                    }
                }, 10);
            },
            //获取短信验证码
            getMobileCode() {
                var _this = this;
                if (!_this.mobileValidateCheck()) {
                    return;
                }
                if (!_this.isCanGetMobileCode) {
                    return;
                }
                _this.isShowTip2 = false;
                _this.loading = true;
                var params = {
                    mobileNum: _this.mobileLogin.mobile.trim(),
                    sessionId: "dsads"
                };
                setTimeout(function () {
                    _this.$http.jsonp(url.sendSmsCode, {
                        params: params,
                        jsonp: 'jsonpCallback'
                    }).then(function (res) {
                        _this.loading = false;
                        _this.hasClickGetMobileCode = true; //已经获取过短信验证码
                        var res = res.body;
                        if (res.status == "ERROR") {
                            _this.isShowTip2 = true;
                            _this.isTab2Success = false;
                            if (res.errorCode == "timeOut") {
                                _this.tipMsg2 = "页面信息已失效,请重新刷新页面！";
                            }else if (res.errorCode == "userUnExist") {
                                _this.tipMsg2 = "该手机号码尚未注册!";
                            } else if (res.errorCode == "accountLockedForever") {
                                _this.tipMsg2 = "账户被永久锁定，请与客服人员联系！";
                            } else if (res.errorCode == "accountLocked") {
                                _this.tipMsg2 = "账户已锁定，请2小时后重试！";
                            } else if (res.errorCode == "daySendTooMuch") {
                                _this.tipMsg2 = "今日已到最大发送次数,请明日再试！";
                            } else if (res.errorCode == "hourSendTooMuch") {
                                _this.tipMsg2 = "动态码发送频繁,请稍后再试！";
                            } else {
                                _this.tipMsg2 = "验证码发送失败";
                            }
                        } else {
                            _this.smsId = res.result;
                            _this.isShowTip2 = true;
                            _this.isTab2Success = true;
                            _this.tipMsg2 = "验证码已发送到您手机，2分钟内输入有效!";
                            var seconds = 120;
                            _this.isCanGetMobileCode = false;
                            _this.hasClickGetMobileCode = true;
                            _this.getMobileCodeTxt = seconds + "s";
                            var timer = setInterval(function () {
                                if (seconds > 1) {
                                    seconds--;
                                    _this.getMobileCodeTxt = seconds + "s";
                                } else {
                                    _this.getMobileCodeTxt = "点击获取";
                                    _this.isCanGetMobileCode = true;
                                    clearInterval(timer);
                                }
                            }, 1000);
                        }
                    }).catch(function () {
                        _this.loading = false;
                        _this.$Message.error('数据获取失败,请稍后再试!');
                    });
                }, 1000);
            },
            changeTabShow(index) {
                var _this = this;
                _this.title.forEach(function (item, i) {
                    if (index == i) {
                        _this.title[i].isSelected = true;
                        _this.isShowTab1 = false;
                    } else {
                        _this.title[i].isSelected = false;
                        _this.isShowTab1 = true;
                    }
                });
            },
            closeLoginDialog() {
                this.$store.commit('changeShowLoginDialogState');
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "../../../static/scss/page/loginDialog.scss";
</style>
<style lang="scss">
    .login-dialog-content {
        margin-top: 30px;
        .ivu-form-item {
            margin-bottom: 0 !important;
        }
        .form-item {
            .ivu-input {
                width: 100%;
                height: 44px;
                /*border: #ddd 1px solid;*/
                border-radius: 5px;
                margin: 0;
                padding: 0 0 0 65px;
                box-sizing: border-box;
                font-size: 14px;
                line-height: 44px;
                &:focus {
                    border: 1px solid transparent;
                    box-shadow: 0 0 1px 1px #ff9913;
                }
            }
            .img-code-input {
                .ivu-input {
                    padding-right: 100px;
                }
            }
        }
        .remember-count {
            font-size: 14px;
            .ivu-checkbox {
                margin-right: 10px;
            }
        }
        .ivu-form-item-error-tip {
            padding-left: 15px;
            &:before {

                content: "";
                display: inline-block;
                background: url("../../../static/img/error_icon.png") no-repeat;
                width: 13px;
                height: 13px;
                position: absolute;
                top: 5px;
                left: 0;
            }
        }
        .mobile-code {
            width: 68%;
            float: left;
        }
        .time-count {
            span {
                font-size: 14px;
                color: #336fb3;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Common/LoginDialog.vue